// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCX0bdKztWxKfMgBJ6Oa9lkSXkWT_OWdYw",
  authDomain: "component-library-ceac0.firebaseapp.com",
  projectId: "component-library-ceac0",
  storageBucket: "component-library-ceac0.firebasestorage.app",
  messagingSenderId: "1033904015130",
  appId: "1:1033904015130:web:522525fabe8567675dcea3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export { auth, app };
